export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};